import { render } from "./DialogError.vue?vue&type=template&id=5db1ef83&scoped=true"
import script from "./DialogError.vue?vue&type=script&lang=js"
export * from "./DialogError.vue?vue&type=script&lang=js"

import "./DialogError.vue?vue&type=style&index=0&id=5db1ef83&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db1ef83"]])

export default __exports__